import React, { useEffect, useRef, useState } from "react";
import Draggable from "react-draggable";
import { TransformComponent, useControls } from "react-zoom-pan-pinch";

export default function DragAndDrop({ imgShow, children }) {
    const [activeDrags, setActiveDrags] = useState(0);
    const dragRef = useRef(null);
    const { resetTransform } = useControls();

    const onStart = () => {
        setActiveDrags(activeDrags + 1);
    };

    const onStop = () => {
        setActiveDrags(activeDrags - 1);
    };

    useEffect(() => {
        if (!imgShow) {
            resetTransform();
        }
    }, [imgShow])

    const dragHandlers = { onStart, onStop, cancel: ".not-draggable" };

    return (
        <TransformComponent>
            {/*<Draggable bounds="parent" {...dragHandlers}>*/}
            {/*    <div ref={dragRef}>{children}</div>*/}
            {/*</Draggable>*/}
            <div style={{display: 'inline-block'}}>
                {children}
            </div>
        </TransformComponent>
    );
}